export default "__VITE_ASSET__D7F4IBS6__"